import { render, staticRenderFns } from "./CmgPaymentCardLogo.vue?vue&type=template&id=a06271e8&scoped=true&lang=pug&"
import script from "./cmg-payment-card-logo.ts?vue&type=script&lang=ts&"
export * from "./cmg-payment-card-logo.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPaymentCardLogo.vue?vue&type=style&index=0&id=a06271e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06271e8",
  null
  
)

export default component.exports